const bannedCountries = new Set([
    'af',
    'bi',
    'by',
    'cd',
    'cf',
    'cu',
    'fx',
    'gn',
    'gw',
    'iq',
    'ir',
    'kp',
    'lb',
    'ly',
    'ml',
    'mm',
    'ng',
    'ni',
    'ru',
    'sd',
    'so',
    'ss',
    'sy',
    'tn',
    'ua',
    've',
    'ye',
    'zw'
]);

const euCountries = new Set([
    'at',
    'be',
    'bg',
    'cy',
    'cz',
    'de',
    'dk',
    'ee',
    'es',
    'fi',
    'fr',
    'gr',
    'hr',
    'hu',
    'ie',
    'it',
    'lt',
    'lu',
    'lv',
    'mt',
    'nl',
    'pl',
    'pt',
    'ro',
    'se',
    'si',
    'sk'
]);

export const removeBannedCountries = (country) =>
    !bannedCountries.has(country.countryCodeIso2.toLowerCase());

export const removeBannedCountryCodes = (countryCodeIso2) =>
    !bannedCountries.has(countryCodeIso2.toLowerCase());

export const getAvailableCountries = (t) => {
    return Object.keys(countries)
        .filter(removeBannedCountryCodes)
        .map((code) => ({
            code,
            name: t(mapCountryCodeToCountryKey(code))
        }))
        .sort((a, b) => (a.name > b.name ? 1 : -1));
};

export const countryIsInEU = (countryCode) =>
    euCountries.has(countryCode.toLowerCase());

// We map this way to ensure that each key in lokalise is present in code.
// This allows us to clean up unnecessary codes in the future.
export const mapCountryCodeToCountryKey = (countryCode) => {
    const lokaliseKey = countries[countryCode.toLowerCase()];
    if (!lokaliseKey)
        throw `CountryCode ${countryCode} has no mapping to lokalise key`;
    return lokaliseKey;
};

export const countries = {
    ad: 'country_ad',
    ae: 'country_ae',
    af: 'country_af',
    ag: 'country_ag',
    ai: 'country_ai',
    al: 'country_al',
    am: 'country_am',
    an: 'country_an',
    ao: 'country_ao',
    aq: 'country_aq',
    ar: 'country_ar',
    as: 'country_as',
    at: 'country_at',
    au: 'country_au',
    aw: 'country_aw',
    ax: 'country_ax',
    az: 'country_az',
    ba: 'country_ba',
    bb: 'country_bb',
    bd: 'country_bd',
    be: 'country_be',
    bf: 'country_bf',
    bg: 'country_bg',
    bh: 'country_bh',
    bi: 'country_bi',
    bj: 'country_bj',
    bm: 'country_bm',
    bn: 'country_bn',
    bo: 'country_bo',
    br: 'country_br',
    bs: 'country_bs',
    bt: 'country_bt',
    bv: 'country_bv',
    bw: 'country_bw',
    by: 'country_by',
    bz: 'country_bz',
    ca: 'country_ca',
    cc: 'country_cc',
    cd: 'country_cd',
    cf: 'country_cf',
    cg: 'country_cg',
    ch: 'country_ch',
    ci: 'country_ci',
    ck: 'country_ck',
    cl: 'country_cl',
    cm: 'country_cm',
    cn: 'country_cn',
    co: 'country_co',
    cr: 'country_cr',
    cu: 'country_cu',
    cv: 'country_cv',
    cx: 'country_cx',
    cy: 'country_cy',
    cz: 'country_cz',
    de: 'country_de',
    dj: 'country_dj',
    dk: 'country_dk',
    dm: 'country_dm',
    do: 'country_do',
    dz: 'country_dz',
    ec: 'country_ec',
    ee: 'country_ee',
    eg: 'country_eg',
    eh: 'country_eh',
    er: 'country_er',
    es: 'country_es',
    et: 'country_et',
    fi: 'country_fi',
    fj: 'country_fj',
    fk: 'country_fk',
    fm: 'country_fm',
    fo: 'country_fo',
    fr: 'country_fr',
    fx: 'country_fx',
    ga: 'country_ga',
    gb: 'country_gb',
    gd: 'country_gd',
    ge: 'country_ge',
    gf: 'country_gf',
    gh: 'country_gh',
    gi: 'country_gi',
    gl: 'country_gl',
    gm: 'country_gm',
    gn: 'country_gn',
    gp: 'country_gp',
    gq: 'country_gq',
    gr: 'country_gr',
    gs: 'country_gs',
    gt: 'country_gt',
    gu: 'country_gu',
    gw: 'country_gw',
    gy: 'country_gy',
    hk: 'country_hk',
    hm: 'country_hm',
    hn: 'country_hn',
    hr: 'country_hr',
    ht: 'country_ht',
    hu: 'country_hu',
    id: 'country_id',
    ie: 'country_ie',
    il: 'country_il',
    in: 'country_in',
    io: 'country_io',
    iq: 'country_iq',
    ir: 'country_ir',
    is: 'country_is',
    it: 'country_it',
    jm: 'country_jm',
    jo: 'country_jo',
    jp: 'country_jp',
    ke: 'country_ke',
    kg: 'country_kg',
    kh: 'country_kh',
    ki: 'country_ki',
    km: 'country_km',
    kn: 'country_kn',
    kp: 'country_kp',
    kr: 'country_kr',
    kw: 'country_kw',
    ky: 'country_ky',
    kz: 'country_kz',
    la: 'country_la',
    lb: 'country_lb',
    lc: 'country_lc',
    li: 'country_li',
    lk: 'country_lk',
    lr: 'country_lr',
    ls: 'country_ls',
    lt: 'country_lt',
    lu: 'country_lu',
    lv: 'country_lv',
    ly: 'country_ly',
    ma: 'country_ma',
    mc: 'country_mc',
    md: 'country_md',
    mg: 'country_mg',
    mh: 'country_mh',
    mk: 'country_mk',
    ml: 'country_ml',
    mm: 'country_mm',
    mn: 'country_mn',
    mo: 'country_mo',
    mp: 'country_mp',
    mq: 'country_mq',
    mr: 'country_mr',
    ms: 'country_ms',
    mt: 'country_mt',
    mu: 'country_mu',
    mv: 'country_mv',
    mw: 'country_mw',
    mx: 'country_mx',
    my: 'country_my',
    mz: 'country_mz',
    na: 'country_na',
    nc: 'country_nc',
    ne: 'country_ne',
    nf: 'country_nf',
    ng: 'country_ng',
    ni: 'country_ni',
    nl: 'country_nl',
    no: 'country_no',
    np: 'country_np',
    nr: 'country_nr',
    nu: 'country_nu',
    nz: 'country_nz',
    om: 'country_om',
    pa: 'country_pa',
    pe: 'country_pe',
    pf: 'country_pf',
    pg: 'country_pg',
    ph: 'country_ph',
    pk: 'country_pk',
    pl: 'country_pl',
    pm: 'country_pm',
    pn: 'country_pn',
    pr: 'country_pr',
    ps: 'country_ps',
    pt: 'country_pt',
    pw: 'country_pw',
    py: 'country_py',
    qa: 'country_qa',
    re: 'country_re',
    ro: 'country_ro',
    ru: 'country_ru',
    rs: 'country_rs',
    rw: 'country_rw',
    sa: 'country_sa',
    sb: 'country_sb',
    sc: 'country_sc',
    sd: 'country_sd',
    se: 'country_se',
    sg: 'country_sg',
    sh: 'country_sh',
    si: 'country_si',
    sj: 'country_sj',
    sk: 'country_sk',
    sl: 'country_sl',
    sm: 'country_sm',
    sn: 'country_sn',
    so: 'country_so',
    sr: 'country_sr',
    st: 'country_st',
    sv: 'country_sv',
    sy: 'country_sy',
    sz: 'country_sz',
    tc: 'country_tc',
    td: 'country_td',
    tf: 'country_tf',
    tg: 'country_tg',
    th: 'country_th',
    tj: 'country_tj',
    tk: 'country_tk',
    tl: 'country_tl',
    tm: 'country_tm',
    tn: 'country_tn',
    to: 'country_to',
    tr: 'country_tr',
    tt: 'country_tt',
    tv: 'country_tv',
    tw: 'country_tw',
    tz: 'country_tz',
    ua: 'country_ua',
    ug: 'country_ug',
    um: 'country_um',
    us: 'country_us',
    uy: 'country_uy',
    uz: 'country_uz',
    va: 'country_va',
    vc: 'country_vc',
    ve: 'country_ve',
    vg: 'country_vg',
    vi: 'country_vi',
    vn: 'country_vn',
    vu: 'country_vu',
    wf: 'country_wf',
    ws: 'country_ws',
    ye: 'country_ye',
    yt: 'country_yt',
    yu: 'country_yu',
    za: 'country_za',
    zm: 'country_zm',
    zw: 'country_zw'
};
